import { render, staticRenderFns } from "./FinalizeBatchPopup.vue?vue&type=template&id=36720587"
import script from "./FinalizeBatchPopup.vue?vue&type=script&lang=js"
export * from "./FinalizeBatchPopup.vue?vue&type=script&lang=js"
import style0 from "./FinalizeBatchPopup.vue?vue&type=style&index=0&id=36720587&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports